import { color } from '@upstox/upstox-ui';

export const container: CSSFunction = ({ theme }) => ({
  display: 'flex',
  padding: '8px 12px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '12px',
  alignSelf: 'stretch',
  background: color(theme, 'ui1'),
});

export const toggleContainer: CSSFunction = () => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  cursor: 'pointer',
});

export const showMoreLessArrow: CSSFunction = ({ theme }) => ({
  height: '16px',
  color: color(theme, 'text.2'),
});

export const header: CSSFunction = () => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const totalCharges: CSSFunction = () => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const chargesDescription: CSSFunction = () => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const chargesList: CSSFunction = () => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const disclaimer: CSSFunction = () => ({
  display: 'flex',
  flexDirection: 'column',
});

export const disclaimerText = {
  marginLeft: '4px',
};

export const disclaimerCharges = {
  listStyleType: 'disc',
  paddingLeft: '12px',
};

export const topDivider: CSSFunction = () => ({
  marginBottom: '12px',
});
